
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger, AlertDialogCancel } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Power, Loader2 } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface UnenrollDeviceProps {
  deviceId: string;
  deviceName: string;
}

const UnenrollDevice = ({ deviceId, deviceName }: UnenrollDeviceProps) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleUnenroll = async () => {
    try {
      setIsDeleting(true);
      console.log('Unenrolling device:', deviceId);

      const { error } = await supabase
        .from('devices')
        .update({
          status: 'unenrolled',
          last_seen: new Date().toISOString()
        })
        .eq('id', deviceId);

      if (error) throw error;

      toast.success('Device unenrolled successfully');
      // Removed the navigate call since we want to stay on the current page
    } catch (error) {
      console.error('Error unenrolling device:', error);
      toast.error('Failed to unenroll device. Please try again.');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="destructive" className="w-full justify-start">
          <Power className="mr-2 h-4 w-4" />
          Unenroll Device
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Unenroll Device</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to unenroll {deviceName}? The device will be marked as unenrolled and will no longer be able to check in.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <Button 
            variant="destructive" 
            onClick={handleUnenroll}
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Unenrolling...
              </>
            ) : (
              'Unenroll'
            )}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default UnenrollDevice;
